/*
    绿地Ape World数字藏品 
*/

import React, { useState, useEffect, useRef } from "react";
import Rotate3D from "@/components/Rotate3D";
import "./index.scss";

const WordWhatCard = (props)=> {

    const {dataSouce={}} = props

    const sources = [
        {
            source:require("@/assets/img/ape-world/cartoon_front.png"),
            direction: 'front'
        },
        {
            source:require("@/assets/img/ape-world/cartoon_front.png"),
            direction: 'back'
        },
        {
            source:require("@/assets/img/ape-world/cartoon_left.png"),
            direction: 'left'
        },
        {
            source:require("@/assets/img/ape-world/cartoon_left.png"),
            direction: 'right'
        },
        {
            source:require("@/assets/img/ape-world/cartoon_top.png"),
            direction: 'up'
        },
        {
            source:require("@/assets/img/ape-world/cartoon_top.png"),
            direction: 'down'
        }
    ]

    return (
        <div className="WordWhatCard">
            <span>{ dataSouce.title || '绿地Ape World数字藏品'}</span>
            <div className="ape_world_content">
                <div className="content_display">
                    <img src={require('@/assets/img/ape-world/sale_bg.png')}/>
                    <Rotate3D sources={sources} />
                </div>
            </div>
        </div>
    )
}

export default WordWhatCard;